import React, { useState, useEffect, useRef } from 'react';
import HeroBgAnimation from '../HeroBgAnimation';
import { HeroContainer, HeroBg, HeroLeftContainer, Img, HeroRightContainer, HeroInnerContainer, TextLoop, Title, Span, SubTitle, ResumeButton } from './HeroStyle';
import HeroImg from '../../images/HeroImage.jpg';
import Typewriter from 'typewriter-effect';
import { Bio } from '../../data/constants';
import Tilt from 'react-parallax-tilt';

const HeroSection = () => {
    const [isVisible, setIsVisible] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const heroRef = useRef(null);

    useEffect(() => {
        // Check if device is mobile
        const checkMobile = () => {
            setIsMobile(window.matchMedia('(max-width: 768px)').matches);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);

        // Lazy load background animation using Intersection Observer
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setIsVisible(true);
                        observer.disconnect(); // Stop observing after animation loads
                    }
                });
            },
            { threshold: 0.1 }
        );

        if (heroRef.current) {
            observer.observe(heroRef.current);
        }

        return () => {
            window.removeEventListener('resize', checkMobile);
            observer.disconnect();
        };
    }, []);

    return (
        <div id="about" ref={heroRef}>
            <HeroContainer>
                <HeroBg>
                    {isVisible && <HeroBgAnimation />}
                </HeroBg>
                <HeroInnerContainer>
                    <HeroLeftContainer id="Left" className="cursor-scale">
                        <Title className="cursor-scale">Hi, I am <br /> {Bio.name}</Title>
                        <TextLoop className="cursor-scale">
                            I am a
                            <Span className="cursor-scale small">
                                <Typewriter
                                    options={{
                                        strings: Bio.roles,
                                        autoStart: true,
                                        loop: true,
                                    }}
                                />
                            </Span>
                        </TextLoop>
                        <SubTitle className="cursor-scale">{Bio.description}</SubTitle>
                        <ResumeButton href={Bio.resume} target='display' className="cursor-scale">Check Resume</ResumeButton>
                    </HeroLeftContainer>

                    <HeroRightContainer id="Right">
                        <Tilt
                            tiltMaxAngleX={isMobile ? 0 : 25}
                            tiltMaxAngleY={isMobile ? 0 : 25}
                            scale={isMobile ? 1 : 1.05}
                            tiltEnable={!isMobile}
                        >
                            <Img src={HeroImg} alt="hero-image" />
                        </Tilt>
                    </HeroRightContainer>
                </HeroInnerContainer>
            </HeroContainer>
        </div>
    );
}

export default HeroSection;
